import React, {useState} from 'react'
import { FaCheck, FaTimes, FaEye, FaEyeSlash } from 'react-icons/fa'
import VisDiv from '../whitaijiFrontendLibrary/components/VisDiv'
import { useStateContext } from '../context/StateContext'
import { useAuthContext } from '../whitaijiFrontendLibrary/auth/hooks/useAuthContext';
import { AuthContext } from '../context/AuthContext';
import { useLogin } from '../whitaijiFrontendLibrary/auth/hooks/useLogin'
import { blueColour } from './Home';
import T from '../components/Translation';
import BlueButton from '../components/BlueButton';


const ChangePassword = () => {
    const [newPassword, setNewPassword] = useState("")  
    const [confirmPassword, setConfirmPassword] = useState("") 
    const [showNewPassword, setShowNewPassword] = useState(false)
    const [showConfirmPassword, setShowConfirmPassword] = useState(false)
    const { apiUrl } = useStateContext()
    const { user, dispatch } = useAuthContext(AuthContext)
    const {updatePassword, error, isLoading} = useLogin(AuthContext)
    
    // Password validation state
    const [passwordValidation, setPasswordValidation] = useState({
        minLength: false,
        minLowercase: false,
        minUppercase: false,
        minNumbers: false,
        minSymbols: false,
        passwordConfirmed: false
    })
    const handlePasswordChange = (e) => {
        const password = e.target.value;
        setNewPassword(password);
        
        // Update validation states
        setPasswordValidation({
            minLength: password.length >= 8,
            minLowercase: /[a-z]/.test(password),
            minUppercase: /[A-Z]/.test(password),
            minNumbers: /[0-9]/.test(password),
            minSymbols: /[!@#$%^&*(),.?":{}|<>]/.test(password),
            passwordConfirmed: password === confirmPassword
        });
    };

    const handleConfirmPasswordChange = (e) => {
        const confirmPwd = e.target.value;
        setConfirmPassword(confirmPwd);
        
        // Update validation state for password confirmation
        setPasswordValidation(prev => ({
            ...prev,
            passwordConfirmed: newPassword === confirmPwd
        }));
    };

    const ValidationItem = ({ isValid, text }) => (
        <div style={{ 
            display: 'flex', 
            alignItems: 'center', 
            gap: '8px',
            color: isValid ? '#4CAF50' : '#f44336',
            marginBottom: '4px',
            fontSize: '14px'
        }}>
            {isValid ? <FaCheck /> : <FaTimes />}
            {text}
        </div>
    );

/*     const updatePassord = async (newPassword) => {
        const request = async (req, res) => {
          try {
            const response = await axios.post(
                `${apiUrl}/user/update-password`, 
                { newPassword, user },
                {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${user.token}`
                }
                }
            );

            if (response.status === 200) {
              const data = response.data
                const doc = {...user, changePassword: false}
                //localStorage.setItem('user', JSON.stringify(doc))
                dispatch({type: 'LOGIN', payload: doc})
            } 
          } catch (error) {
            process.env.NODE_ENV === "development" && console.log("CATCH ERROR", error)
            setUpdateError(error?.response?.data?.error);
          }
        }

        request()
    } */

    return (
        <div style={{width:"100%", height:"100vh"}}>
            <div style={{ width:"100%", height: "100%", display:"flex", flexDirection:"column", marginTop:"30px", alignItems:"center", color:"white"}}>
                <VisDiv rules={[true]}>
                    <label style={{color: blueColour}}>{<T obj={{en: "Change password", it: "Cambia la password"}}/>}</label>
                    <div style={{ position: 'relative', width: '100%' }}>
                        <input 
                            style={{color: blueColour, width: '100%'}}  
                            type={showNewPassword ? "text" : "password"} 
                            onChange={handlePasswordChange} 
                            value={newPassword} 
                        />
                        <div 
                            onClick={() => setShowNewPassword(!showNewPassword)} 
                            style={{ 
                                position: 'absolute', 
                                right: '10px', 
                                top: '50%', 
                                transform: 'translateY(-50%)', 
                                cursor: 'pointer',
                                color: blueColour
                            }}
                        >
                            {showNewPassword ? <FaEyeSlash /> : <FaEye />}
                        </div>
                    </div>
                    <VisDiv rules={[newPassword]}>
                        <label style={{color: blueColour}}><T obj={{en: "Confirm password", it: "Conferma la password"}}/></label>
                        <div style={{ position: 'relative', width: '100%' }}>
                            <input 
                                style={{color: blueColour, width: '100%'}}  
                                type={showConfirmPassword ? "text" : "password"} 
                                onChange={handleConfirmPasswordChange} 
                                value={confirmPassword} 
                            />
                            <div 
                                onClick={() => setShowConfirmPassword(!showConfirmPassword)} 
                                style={{ 
                                    position: 'absolute', 
                                    right: '10px', 
                                    top: '50%', 
                                    transform: 'translateY(-50%)', 
                                    cursor: 'pointer',
                                    color: blueColour
                                }}
                            >
                                {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
                            </div>
                        </div>
                    </VisDiv>
                    <div style={{ marginTop: '10px', marginBottom: '10px' }}>
                        <ValidationItem isValid={passwordValidation.minLength} text="Almeno 8 caratteri" />
                        <ValidationItem isValid={passwordValidation.minLowercase} text="Almeno 1 lettera minuscola" />
                        <ValidationItem isValid={passwordValidation.minUppercase} text="Almeno 1 lettera maiuscola" />
                        <ValidationItem isValid={passwordValidation.minNumbers} text="Almeno 1 numero" />
                        <ValidationItem isValid={passwordValidation.minSymbols} text="Almeno 1 carattere speciale" />
                        <ValidationItem isValid={passwordValidation.passwordConfirmed} text="Conferma la password" />
                    </div>
                </VisDiv>
                <VisDiv rules={[
                    newPassword && 
                    confirmPassword &&
                    passwordValidation.minLength && 
                    passwordValidation.minLowercase && 
                    passwordValidation.minUppercase && 
                    passwordValidation.minNumbers && 
                    passwordValidation.minSymbols && 
                    passwordValidation.passwordConfirmed
                ]}> 
                    <BlueButton fn={() => updatePassword(newPassword, user)} text={<T obj={{en: "Change password", it: "Cambia la password"}}/>} />
                </VisDiv>
{/*                 <div onClick={() => setBypassNewPassword(true)} className="login-button">
                    SALTA
                </div> */}
                <VisDiv rules={[error]}>
                    {<div style={{background:"rgba(0,0,0,0)"}} className="error">{error}</div>}
                </VisDiv>
            </div>
        </div>
    )
}


export default ChangePassword
